import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_search0",
  "use": "icon_search0-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon_search0\"><defs><style type=\"text/css\">@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n</style></defs><path d=\"M469.344 789.344c176.736 0 320-143.264 320-320s-143.264-320-320-320-320 143.264-320 320 143.264 320 320 320z m296.864-44.032l136.704 139.936a42.656 42.656 0 0 1-61.056 59.616l-140.096-143.424a403.488 403.488 0 0 1-232.416 73.216C245.44 874.656 64 693.216 64 469.344S245.472 64 469.344 64c223.84 0 405.312 181.472 405.312 405.344 0 106.592-41.152 203.584-108.448 275.968z\" p-id=\"2369\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/search0.svg
// module id = WhGc
// module chunks = 54